import script from "./SuggestionsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionsSearch.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionsSearch.vue?vue&type=style&index=0&id=f08eb3be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f08eb3be"]])

export default __exports__